import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {BasicEvent} from 'util/Types';
import {ExperimentalCondition} from 'workflows/WorkflowConstants';

function DeletableTextFieldRow(props: DeletableTextFieldRowProps): JSX.Element {
  return (
    <div className="workflowConfigureScreen-deletable-row u-flex-display u-tiny-spacing-bottom">
      <div className="u-flex-grow">
        <input
          className="fieldInput-input"
          value={props.value}
          onChange={(e) => {
            props.onEditValue(e.target.value);
          }}
          placeholder={props.placeholder}
          type="text"
        />
      </div>
      <div
        className="u-flex-none u-vertical-center-items u-justify-content-center u-tiny-spacing-left"
        style={{width: 30}}
      >
        <BenchlingIcon
          className="workflowConfigureScreen-delete faded u-danger-pointer"
          icon="delete"
          onClick={props.onDeleteValue}
        />
      </div>
    </div>
  );
}

interface DeletableTextFieldRowProps {
  value: string;
  placeholder: string;
  onEditValue: (value: string) => void;
  onDeleteValue: (e: BasicEvent) => void;
}

function ExperimentalConditionTable(props: ExperimentalConditionTableProps): JSX.Element {
  return (
    <div className="workflowConfigureScreen-groupBox">
      <FieldLabel label="Name" />
      <DeletableTextFieldRow
        value={props.experimentalCondition.name}
        placeholder="Enter condition name here"
        onEditValue={props.onEditName}
        onDeleteValue={props.onDeleteCondition}
      />
      <div className="u-spacing-top">
        <FieldLabel
          label={
            <div>
              <span>Options</span>
              <BenchlingIcon
                className="workflowConfigureScreen-compose u-pointer"
                icon="compose"
                onClick={() => {
                  props.onCreateValue();
                }}
              />
            </div>
          }
        />
      </div>
      {props.experimentalCondition.values.map((ecValue, valueIndex) => (
        <DeletableTextFieldRow
          key={valueIndex}
          value={ecValue.textValue}
          placeholder="Enter value name here"
          onEditValue={(value) => {
            props.onEditValue(valueIndex, value);
          }}
          onDeleteValue={() => {
            props.onDeleteValue(valueIndex);
          }}
        />
      ))}
    </div>
  );
}

interface ExperimentalConditionTableProps {
  experimentalCondition: ExperimentalCondition;
  onEditName: (name: string) => void;
  onDeleteCondition: (e: BasicEvent) => void;
  onCreateValue: () => void;
  onDeleteValue: (valueIndex: number) => void;
  onEditValue: (valueIndex: number, value: string) => void;
}

export default ExperimentalConditionTable;
